
const dpm ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Science+%26+Humanity/boy.webp"
const ccover = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/science_humanities/Chemistry/Chem_faculties/chemi+cover.webp";
const loki = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/science_humanities/Chemistry/Chem_faculties/loki.webp";
const thenraj = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/science_humanities/Chemistry/Chem_faculties/thenraj.webp";
const rajaperumal = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/science_humanities/Chemistry/Chem_faculties/rajaperuma.webp"; 
const vijayalakshmi = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/science_humanities/Chemistry/Chem_faculties/vijayalakshmi.webp";
const lakshmi = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/science_humanities/Chemistry/Chem_faculties/lakshmi_narayanan.webp";

const Chemistry_dept_fmenu = [
    {
      id: "1",
      path: "/chemistrydept",
      link: "About the Department",
      arl: "l",
    },
    {
      id: "2",
      path: "/chemistrydept/chemistry-faculty",
      link: "Faculty",
      arl: "1",
    },
    {
      id: "3",
      path: "/chemistrydept/chemistry-lab-facility",
      link: "Laboratory Facilities",
      arl: "1",
    },
    {
      id: "4",
      path: "/chemistrydept/chemistry-research",
      link: "Research and Publications",
      arl: "1",
    },
    {
      id: "5",
      path: "/chemistrydept/chemistry-programme",
      link: "Programme Organized",
      arl: "1",
    },
  ];

  const chemi_vision = {
    id: "1",
    visiondata:
      "To be a best centre in Chemistry of the new innovative world. To ensure the implementation of the science of Chemistry in day-to-day life.",
  };
  
const chemi_mission = [
    {
      id: "1",
      mission:
        " To provide advanced education with skilled knowledge to the students to face the global challenges. ",
    },
    {
        id: "2",
        mission:
          "  To motivate the students to acquire technical, critical and innovative thinking skills in Chemistry to create a new world. ",
      },
      {
        id: "3",
        mission:
          "To help learners learn the art of creating an eco-friendly environment. ",
      },
      {
        id: "4",
        mission:
          "To teach learners to interpret life through the science of Chemistry. ",
      },
];

const chemi_fac_profiles = [
        {
          id: "1",
          cover: ccover,
          dp: loki,
          name: "K.T.Loganathan",
          Designation: "Assistant Professor and Head of the Department",
          mailid: "logchem80@gmail.com",
          pdf: "https://drive.google.com/file/d/1JujcMUsFo6rWqzcwv2_BQf203WU9M7au/view?usp=drive_link",
        },
        {
          id: "2",
          cover: ccover,
          dp: thenraj,
          name: "Dr.M.Thenraj",
          Designation: "Assistant Professor",
          mailid: "mtr.iisc@gmail.com",
          pdf: "https://drive.google.com/file/d/1r-WWKM3kXRz6NNzafirdn9LoZHHF7CYQ/view?usp=drive_link",
        },
        {
          id: "3",
          cover: ccover,
          dp: rajaperumal,
          name: "M.Rajaperumal",
          Designation: "Assistant Professor",
          mailid: "rajaperumalsjc@gmail.com",
          pdf: "https://drive.google.com/file/d/1jQ0lSaFxDO5pTyFQJT0KGQg7P7Zgx_fu/view?usp=drive_link",
        },
        {
          id: "4",
          cover: ccover,
          dp: vijayalakshmi,
          name: "K.Vijayalakshmi",
          Designation: "Assistant Professor(Adhoc)(On contract basis)",
          mailid: "vijayalakshmi2280@gmail.com",
          pdf: "https://drive.google.com/file/d/1qcVYRilzusVWm9GLx2keEPOQa4lAagnM/view?usp=drive_link",
        },
];
      
const chemi_sup_profiles = [
        {
          id: "1",
          cover: ccover,
          dp: dpm,
          name: "M.Mahamani",
          Designation: "Lab Assistant",
          mailid: "mahamaniaccet1964@gmail.com",
          pdf: "https://drive.google.com/file/d/1Ha1XHPwh2bBtU9mf4ys3R3fXrXyAIY4s/view?usp=drive_link",
        },
        {
          id: "2",
          cover: ccover,
          dp: lakshmi,
          name: "K.Lakshmi Narayanan",
          Designation: "Cleaner",
          mailid: "klakshminarayanan121@gmail.com",
          pdf: "https://drive.google.com/file/d/19RVQUZejoy4c34KW7IZ7H352yQiRdjmH/view?usp=drive_link",
        },
];

const chemi_prog = [
    {
      sno: "1",
      name: "TEQIP III sponsored one week induction programme to I year BE students",
      period: "23.10.17 to 29.10.17",
      par: 360,
    },
    {
      sno: "2",
      name: "TEQIP III Sponsored two day workshop on “ESPERANZIA” for I year BE students",
      period: "22.03.18 to 23.03.18",
      par: 360,
    },
    {
      sno: "3",
      name: "TEQIP III sponsored one day FDP on “E-Procurement",
      period: "09.10.18",
      par: 28,
    },
    {
      sno: "4",
      name: "TEQIP III sponsored three week induction programme for I year BE",
      period: "13.08.18 to 02.09.18",
      par: 380,
    },
  ];

  const chemi_research_l = [
    {
      id: "1",
      point:
        "Loganathan K T, Aditya P. Pandey, Uday Kumar Padidela, and Ramakrishnan Sethu, in collaboration with Pothiappan Vairaprakash and Venkatesan S. Thimmakondu*, conducted research on MgC6H2 isomers, which are considered potential candidates for laboratory and radioastronomical studies. Their findings were published in the Journal of Physical Chemistry A in 2020, Volume 124, Issue 37, pages 7518–7525.",
    },
  ];
  
  const chemi_research_R = [
    {
      id: "1",
      point:
        "M. Rajaperumal provided a commentary on the paper titled 'Microwave synthesis of graphene/magnetite composite electrode material for symmetric supercapacitor with superior rate performance' authored by K. Karthikeyan, D. Kalpana, S. Amaresh, and Y. S. Lee, published in RSC Advances in 2017, with the reference pages 47332-47334.",
    },
    {
      id: "2",
      point:
        "M. Rajaperumal collaborated with K. Sivakumar and C. Sivanesan on research involving the production of biodiesel and emission analysis using Karanja (Pongamia) non-edible vegetable oil. This work was published in the International Research Journal of Engineering and Technology.",
    },
  ];

  export {
    Chemistry_dept_fmenu,
    chemi_vision,
    chemi_mission,
    chemi_fac_profiles,
    chemi_sup_profiles,
    chemi_prog,
    chemi_research_l,
    chemi_research_R,
  };